import Flex from 'components/Flex'
import styled from 'styled-components'

const BREAKPOINT = '999px'

const SidebarPage = styled(Flex)`
  padding: ${({ padding }) => {
    return padding ? '0px' : '30px'
  }};

  border-radius: 10px;

  background: #ffffff;
  flex-direction: column;
  min-height: 85vh;
  background-color: #fafafb;
  flex-grow: 1;
  height: calc(100vh - 82px);
  overflow-y: auto;
  // &::-webkit-scrollbar {
  //   display: none;
  // }

  @media screen and (max-width: ${'1500px'}) {
    width: 87%;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
  }
  @media screen and (max-width: ${'1400px'}) {
    width: 85%;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
  }
  @media screen and (max-width: ${BREAKPOINT}) {
    width: 78%;
    overflow-x: hidden;
    box-sizing: border-box;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
  }
`
export default SidebarPage
